<template>
  <div>
    <div class="airlines-pricelist-detail" v-if="!isModalLoading">
      <div class="airlines-pricelist-detail__row">
        <div class="subhead">Bottom Price</div>
        <h1 class="subhead price">{{bottomPrice | formatMoney}}</h1>
      </div>
      <div class="airlines-pricelist-detail__row">
        <div class="subhead">Stock Availability</div>
        <h1>{{pluralize(quantity, 'item')}}</h1>
      </div>
      <div class="airlines-pricelist-detail__row">
        <div class="subhead">Minimum Order Period</div>
        <h1>{{pluralize(minPeriod, minPeriodPlan)}}</h1>
      </div>
      <div class="airlines-pricelist-detail__row">
        <div class="subhead">Minimum Order Quantity</div>
        <h1>{{pluralize(minQuantity, 'item')}}</h1>
      </div>
      <div class="airlines-pricelist-detail__description">
        <h1 class="subhead">Description</h1>
        <div class="subhead">{{description}}</div>
      </div>
    </div>
    <a-loading v-else/>
  </div>
</template>

<script>
import api from '@/api'
import { restEdge } from "@/api/edgeUrls"

import { ALoadingPrimary } from "ui-kit-v1"

export default {
  name: 'adx-airport-placement-detail',
  components: {
    'a-loading': ALoadingPrimary,
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      bottomPrice: null,
      quantity: null,
      minQuantity: null,
      description: null,
      minPeriod: null,
      minPeriodPlan: null,
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isModalLoading = true
      const { data, status } = await api.get(restEdge.airlinesPlacement(this.placementId), { needToken: true, useRestEdge: true })

      if (status === 200) {
        this.bottomPrice = data.bottomPrice
        this.quantity = data.quantity
        this.minQuantity = data.minQuantity
        this.description = data.description
        this.minPeriod = data.minPeriod
        this.minPeriodPlan = data.minPeriodPlan
      }

      this.isModalLoading = false
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`
      }

      return `${value} ${label}`
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>